import {AgGridReact} from "ag-grid-react";
import {AllCommunityModule, ColDef, ModuleRegistry} from "ag-grid-community";
import "../styles/AgGrid.scss"

import React from "react";
import {ScoreWithStats, TypeForm} from "../types";
import {FiEdit} from "react-icons/fi";
import {FaTrash} from "react-icons/fa";
import {handleDelete} from "../utils/handleDeleteClick";
import {useModal} from "../Contexts/Modal";
import {useScores} from "../hooks/useScore";
import FormScore from "./FormScore";

ModuleRegistry.registerModules([AllCommunityModule]);

export function AgGrid({scores, category}: { scores: ScoreWithStats[], category: string }) {
    const {openModal} = useModal();
    const {mutationDelete} = useScores(category);

    const ActionsRenderer = ({data}: { data: ScoreWithStats }) => {
        return (
            <div className="flex gap-2">
                <FiEdit className="action edit" onClick={() => openModal(<FormScore score={data} typeForm={TypeForm.update} category={data.category!} />)}/>
                <FaTrash className="action delete"
                         onClick={() => handleDelete(() => mutationDelete.mutate(data.name))}/>
            </div>
        );
    };

    const columnDefs: ColDef<ScoreWithStats>[] = [
        {field: "date", headerName: "Date"},
        {headerName: "Note", valueGetter: (params) => `${params.data!.score_obtained}/${params.data!.out_of}`,},
        {headerName: "Note sur 20", field: "normalized_score"},
        {headerName: "Coefficient", field: "coefficient"},
        {headerName: "Commentaire", field: "commentary"},
        {
            headerName: "Actions",
            sortable: false,
            cellRenderer: (params: any) => <ActionsRenderer data={params.data}/>,
        }
    ];

    const gridOptions = {
        rowClassRules: {
            'even-row': 'node.rowIndex % 2 === 0', // Applique la classe 'even-row' sur les lignes paires
            'odd-row': 'node.rowIndex % 2 !== 0',  // Applique la classe 'odd-row' sur les lignes impaires
        },
    };


    return (
        <div id={"AgGrid"}>
                <AgGridReact
                    rowData={scores}
                    columnDefs={columnDefs}
                    domLayout="autoHeight"
                    onGridReady={(params) => {
                        params.api.sizeColumnsToFit(); // ⬅️ ajuste la largeur des colonnes
                    }}
                    gridOptions={gridOptions}
                />
        </div>
    )
}